import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import EmailEvent from "./emailevent.component.jsx";

class EmailErrorEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }

    render() {
        const error = this.state.object.attributes.events.filter(e => e.attributes.eventType === "error")[0]
        const errorMessage = error ? error.attributes.message : ''
        return <EmailEvent
            object={this.state.object}
            proposal={this.state.proposal}
            quote={this.state.quote}
            text={<FormattedMessage
                id="quote.analytics.events.email_error.text"
                defaultMessage="There was an error sending your email: {error}"
                values={{
                    error: <em>{errorMessage}</em>
                }}
            />}
            icon={'envelope'}
            iconClassName={'text-danger'}
        />
    }

}

export default EmailErrorEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/email-error.component.jsx